// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-home-container","inner":"pages-home-inner","right":"pages-home-right","small":"pages-home-small"};